/* 🤖 this file was generated by svg-to-ts */
export const DfIconQanda16: {
  name: 'qanda-16';
  data: string;
} = {
  name: 'qanda-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m7.473 11.704.597-.794a6.004 6.004 0 0 0 4.864-6.799A4.002 4.002 0 0 1 16 8.001v.005a4 4 0 0 1-4 4V14.5a.5.5 0 0 1-.9.3L9 12.006c-.54 0-1.057-.108-1.527-.302zM7 9.004l-2.1 2.793a.5.5 0 0 1-.9-.3V9.004c-2.21 0-4-1.792-4-4.002S1.79 1 4 1h3c2.21 0 4 1.792 4 4.002S9.21 9.004 7 9.004z" fill-rule="evenodd"/></svg>`
};
